import { render } from "./ApprovalsListCardHistoryApprovalsCardFields.vue?vue&type=template&id=548ddb3c"
import script from "./ApprovalsListCardHistoryApprovalsCardFields.vue?vue&type=script&lang=js"
export * from "./ApprovalsListCardHistoryApprovalsCardFields.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__